import React from 'react';
import { FormattedMessage } from 'react-intl';
import { FooterSubscribe } from '../FooterSubscribe';
import { SocialLinkRow } from '../SocialLinkRow/SocialLinkRow';
import { socialLinks } from '../links';

export default [
    {
        CustomComponent: FooterSubscribe,
        dataTn: 'footer-subscribe',
        disablerKey: 'disableFooterSubscribe',
    },
    {
        trackingLabel: 'Blog',
        href: 'https://www.1stdibs.com/blogs/the-study/',
        dataTn: 'footer-blog',
        formattedMessage: (
            <FormattedMessage id="dbl.Footer.site_links_blog" defaultMessage="Blog" />
        ),
    },
    {
        trackingLabel: 'Magazine',
        href: 'https://www.1stdibs.com/introspective-magazine/',
        dataTn: 'footer-magazine',
        formattedMessage: (
            <FormattedMessage id="dbl.Footer.site_links_magazine" defaultMessage="Magazine" />
        ),
    },
    {
        CustomComponent: SocialLinkRow,
        items: socialLinks,
        dataTn: 'social-link-row',
    },
];
